import { useConnectivityStore } from 'src/features/connectivity/connectivity-store';

/**
 * Compatibility facade for legacy status badges. The connectivity coordinator is
 * the only owner of probes, listeners, retries, and recovery state.
 */
export function useNetworkStatus() {
  const isOnline = useConnectivityStore((status) => status.runtimeState === 'ONLINE');
  return { isOnline };
}
